module.exports = "images/tiff-big.png";